(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2311],{

/***/ 22769:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"container--e7bf7","is-inline":"is-inline--fda67","isInline":"is-inline--fda67","is-block":"is-block--c90e8","isBlock":"is-block--c90e8","size-sm":"size-sm--9552e","sizeSm":"size-sm--9552e","size-md":"size-md--a869b","sizeMd":"size-md--a869b","size-lg":"size-lg--47a16","sizeLg":"size-lg--47a16"};

/***/ }),

/***/ 79946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ useUniqueID; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_corejs3_core_js_instance_reduce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86432);
/* harmony import */ var _babel_runtime_corejs3_core_js_instance_reduce__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_corejs3_core_js_instance_reduce__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99084);
/* harmony import */ var shortid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30144);
/* harmony import */ var shortid__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(shortid__WEBPACK_IMPORTED_MODULE_2__);





/**
 * This HOC injects unique ids into the lower order component (LOC)
 *
 * 1. It makes sure to generate the unique ids ONCE during creation of the component
 * 2. It allows ids to be passed in as props, which take precedence
 * 3. If the prop provided id changes, the change is passed down to the LOC
 */
const uniqueID = function (propNames) {
  let {
    generate = shortid.generate
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const generateKeysReducer = (obj, key) => ({
    [key]: generate(),
    ...obj
  });
  return LowerOrderComponent => /*#__PURE__*/React.forwardRef((props, ref) => {
    const fallbackIds = React.useRef(_reduceInstanceProperty(propNames).call(propNames, generateKeysReducer, {}));
    return /*#__PURE__*/React.createElement(LowerOrderComponent, _extends({
      ref: ref
    }, fallbackIds.current, props));
  });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (uniqueID)));
const useUniqueID = function (override) {
  let {
    generate = (shortid__WEBPACK_IMPORTED_MODULE_2___default().generate)
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    current: isControlled
  } = react__WEBPACK_IMPORTED_MODULE_1__.useRef(typeof override !== 'undefined');
  const idRef = react__WEBPACK_IMPORTED_MODULE_1__.useRef();
  if (isControlled) {
    return override;
  }
  if (!idRef.current) {
    idRef.current = generate();
  }
  return idRef.current;
};

/***/ }),

/***/ 51197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70509);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99084);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61820);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _InteractiveIcon_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9875);





/**
 * Render an interactive icon as a button. Use this component when the interaction will leave the user
 * in the same url.
 *
 * Passes ref to underlying button
 */
const IconButton = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_ref, ref) => {
  let {
    block,
    size,
    name,
    as,
    ...rest
  } = _ref;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_InteractiveIcon_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__["default"])({
    ref: ref,
    name: name,
    as: as,
    block: block,
    size: size
  }, rest));
});
IconButton.propTypes = {
  /**
   * Icon name
   */
  name: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string.isRequired),
  /**
   * Component to render
   */
  as: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().elementType),
  /**
   * To determine if icon should have a block display
   */
  block: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),
  /**
   * Size class
   */
  size: prop_types__WEBPACK_IMPORTED_MODULE_3___default().oneOf(['sm', 'md', 'lg'])
};
IconButton.defaultProps = {
  block: false,
  size: null,
  as: 'button'
};
IconButton.displayName = 'IconButton';
/* harmony default export */ __webpack_exports__["Z"] = (IconButton);

/***/ }),

/***/ 9875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70509);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99084);
/* harmony import */ var _xo_union_ui_accessibility__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9433);
/* harmony import */ var _icon_sets_v2_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38247);
/* harmony import */ var _css_interactive_icon_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22769);
/* harmony import */ var _css_interactive_icon_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_css_interactive_icon_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Icon_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21647);







const InteractiveIcon = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_ref, ref) => {
  let {
    name,
    className,
    iconSet,
    size,
    as: Type,
    block,
    'aria-label': ariaLabel,
    ...props
  } = _ref;
  const classes = [className, (_css_interactive_icon_css__WEBPACK_IMPORTED_MODULE_1___default().container), block ? (_css_interactive_icon_css__WEBPACK_IMPORTED_MODULE_1___default()["is-block"]) : (_css_interactive_icon_css__WEBPACK_IMPORTED_MODULE_1___default()["is-inline"]), size ? (_css_interactive_icon_css__WEBPACK_IMPORTED_MODULE_1___default())[`size-${size}`] : ''];
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_xo_union_ui_accessibility__WEBPACK_IMPORTED_MODULE_2__/* .Focusable */ .Y, (0,_babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__["default"])({
    ref: ref,
    as: Type,
    className: classes.join(' ')
  }, ariaLabel && {
    'aria-label': ariaLabel
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__["default"])({
    name: name,
    iconSet: iconSet,
    size: size
  }, ariaLabel && {
    'aria-hidden': true
  })));
});
 false ? 0 : void 0;
InteractiveIcon.defaultProps = {
  className: '',
  block: false,
  iconSet: _icon_sets_v2_index_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
  size: null,
  'aria-label': null
};
InteractiveIcon.displayName = 'InteractiveIcon';
/* harmony default export */ __webpack_exports__["Z"] = (InteractiveIcon);

/***/ }),

/***/ 9433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ FocusBoundary; },
/* harmony export */   "Y": function() { return /* binding */ Focusable; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70509);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99084);



const FocusableContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(true);
const useFocusable = () => {
  // Allow code to work in environments that havent upgraded react
  // This is neccessary because this code will be used in pagelets (via buttons)
  if (react__WEBPACK_IMPORTED_MODULE_0__.useContext) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return react__WEBPACK_IMPORTED_MODULE_0__.useContext(FocusableContext);
  }
  return true;
};
/**
 * Render a `FocusBoundary` that allows control over child focusable elements.
 *
 * Focusable children will allow focus if all parent `FocusBoundary`'s are enabled
 */
const FocusBoundary = _ref => {
  let {
    enabled,
    detached,
    children
  } = _ref;
  const parentIsFocusable = useFocusable();
  const isEnabled = enabled && (detached || parentIsFocusable);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(FocusableContext.Provider, {
    value: isEnabled
  }, children);
};
 false ? 0 : void 0;
/**
 * Render an element that can receive focus.
 *
 * If this element has a `FocusBoundary` as a parent, the `FocusBoundary` will have
 * partial control over the `tabIndex` of the underlying `Focusable` element. If the `FocusBoundary`
 * is `enabled`, it will not affect the rendering of the underlying element; otherwise,
 * `tabIndex="-1"` will be passed to the underlying element.
 */
const Focusable = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_ref2, ref) => {
  let {
    as: ComponentToRender,
    ...props
  } = _ref2;
  const focusProps = useFocusable() ? {} : {
    tabIndex: '-1'
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ComponentToRender, (0,_babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__["default"])({
    ref: ref
  }, props, focusProps));
});
Focusable.displayName = 'Focusable';
 false ? 0 : void 0;


/***/ }),

/***/ 2378:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(53740);

module.exports = parent;


/***/ }),

/***/ 26992:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(17408);

module.exports = parent;


/***/ }),

/***/ 83902:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(47590);

module.exports = parent;


/***/ }),

/***/ 69779:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(35815);
var entryVirtual = __webpack_require__(65974);

module.exports = entryVirtual('Array').includes;


/***/ }),

/***/ 18733:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(2540);
var entryVirtual = __webpack_require__(65974);

module.exports = entryVirtual('Array').map;


/***/ }),

/***/ 67292:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototypeOf = __webpack_require__(59433);
var arrayMethod = __webpack_require__(69779);
var stringMethod = __webpack_require__(6016);

var ArrayPrototype = Array.prototype;
var StringPrototype = String.prototype;

module.exports = function (it) {
  var own = it.includes;
  if (it === ArrayPrototype || (isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.includes)) return arrayMethod;
  if (typeof it == 'string' || it === StringPrototype || (isPrototypeOf(StringPrototype, it) && own === StringPrototype.includes)) {
    return stringMethod;
  } return own;
};


/***/ }),

/***/ 30428:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototypeOf = __webpack_require__(59433);
var method = __webpack_require__(18733);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.map;
  return it === ArrayPrototype || (isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.map) ? method : own;
};


/***/ }),

/***/ 6016:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(97293);
var entryVirtual = __webpack_require__(65974);

module.exports = entryVirtual('String').includes;


/***/ }),

/***/ 31088:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(27894);


/***/ }),

/***/ 4002:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(94878);


/***/ }),

/***/ 85220:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(40861);


/***/ }),

/***/ 27894:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(2378);

module.exports = parent;


/***/ }),

/***/ 94878:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(26992);

module.exports = parent;


/***/ }),

/***/ 40861:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(83902);

module.exports = parent;


/***/ }),

/***/ 28477:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(81132);

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};


/***/ }),

/***/ 85968:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toPropertyKey = __webpack_require__(68887);
var definePropertyModule = __webpack_require__(54926);
var createPropertyDescriptor = __webpack_require__(54007);

module.exports = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ 1748:
/***/ (function(module) {

/* global Bun -- Deno case */
module.exports = typeof Bun == 'function' && Bun && typeof Bun.version == 'string';


/***/ }),

/***/ 85546:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(49949);
var classof = __webpack_require__(74965);
var wellKnownSymbol = __webpack_require__(81132);

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),

/***/ 61729:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isRegExp = __webpack_require__(85546);

var $TypeError = TypeError;

module.exports = function (it) {
  if (isRegExp(it)) {
    throw $TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),

/***/ 6087:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(41614);
var apply = __webpack_require__(5043);
var isCallable = __webpack_require__(64960);
var ENGINE_IS_BUN = __webpack_require__(1748);
var USER_AGENT = __webpack_require__(82182);
var arraySlice = __webpack_require__(59497);
var validateArgumentsLength = __webpack_require__(48894);

var Function = global.Function;
// dirty IE9- and Bun 0.3.0- checks
var WRAP = /MSIE .\./.test(USER_AGENT) || ENGINE_IS_BUN && (function () {
  var version = global.Bun.version.split('.');
  return version.length < 3 || version[0] == 0 && (version[1] < 3 || version[1] == 3 && version[2] == 0);
})();

// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
module.exports = function (scheduler, hasTimeArg) {
  var firstParamIndex = hasTimeArg ? 2 : 1;
  return WRAP ? function (handler, timeout /* , ...arguments */) {
    var boundArgs = validateArgumentsLength(arguments.length, 1) > firstParamIndex;
    var fn = isCallable(handler) ? handler : Function(handler);
    var params = boundArgs ? arraySlice(arguments, firstParamIndex) : [];
    var callback = boundArgs ? function () {
      apply(fn, this, params);
    } : fn;
    return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
  } : scheduler;
};


/***/ }),

/***/ 48894:
/***/ (function(module) {

var $TypeError = TypeError;

module.exports = function (passed, required) {
  if (passed < required) throw $TypeError('Not enough arguments');
  return passed;
};


/***/ }),

/***/ 48445:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(37377);
var fails = __webpack_require__(19699);
var isArray = __webpack_require__(79851);
var isObject = __webpack_require__(49949);
var toObject = __webpack_require__(77020);
var lengthOfArrayLike = __webpack_require__(48368);
var doesNotExceedSafeInteger = __webpack_require__(39676);
var createProperty = __webpack_require__(85968);
var arraySpeciesCreate = __webpack_require__(93201);
var arrayMethodHasSpeciesSupport = __webpack_require__(11095);
var wellKnownSymbol = __webpack_require__(81132);
var V8_VERSION = __webpack_require__(59483);

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !arrayMethodHasSpeciesSupport('concat');

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike(E);
        doesNotExceedSafeInteger(n + len);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        doesNotExceedSafeInteger(n + 1);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ 35815:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(37377);
var $includes = (__webpack_require__(17407).includes);
var fails = __webpack_require__(19699);
var addToUnscopables = __webpack_require__(86724);

// FF99+ bug
var BROKEN_ON_SPARSE = fails(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),

/***/ 2540:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(37377);
var $map = (__webpack_require__(16918).map);
var arrayMethodHasSpeciesSupport = __webpack_require__(11095);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 97293:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(37377);
var uncurryThis = __webpack_require__(21481);
var notARegExp = __webpack_require__(61729);
var requireObjectCoercible = __webpack_require__(30849);
var toString = __webpack_require__(80717);
var correctIsRegExpLogic = __webpack_require__(28477);

var stringIndexOf = uncurryThis(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(
      toString(requireObjectCoercible(this)),
      toString(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});


/***/ }),

/***/ 72599:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(37377);
var global = __webpack_require__(41614);
var schedulersFix = __webpack_require__(6087);

var setInterval = schedulersFix(global.setInterval, true);

// Bun / IE9- setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
$({ global: true, bind: true, forced: global.setInterval !== setInterval }, {
  setInterval: setInterval
});


/***/ }),

/***/ 54738:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(37377);
var global = __webpack_require__(41614);
var schedulersFix = __webpack_require__(6087);

var setTimeout = schedulersFix(global.setTimeout, true);

// Bun / IE9- setTimeout additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
$({ global: true, bind: true, forced: global.setTimeout !== setTimeout }, {
  setTimeout: setTimeout
});


/***/ }),

/***/ 44362:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__(72599);
__webpack_require__(54738);


/***/ }),

/***/ 53740:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(67292);

module.exports = parent;


/***/ }),

/***/ 17408:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(30428);

module.exports = parent;


/***/ }),

/***/ 47590:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(44362);
var path = __webpack_require__(3999);

module.exports = path.setTimeout;


/***/ }),

/***/ 21818:
/***/ (function(module) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ 30144:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(79371);


/***/ }),

/***/ 1252:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var randomFromSeed = __webpack_require__(32943);

var ORIGINAL = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-';
var alphabet;
var previousSeed;

var shuffled;

function reset() {
    shuffled = false;
}

function setCharacters(_alphabet_) {
    if (!_alphabet_) {
        if (alphabet !== ORIGINAL) {
            alphabet = ORIGINAL;
            reset();
        }
        return;
    }

    if (_alphabet_ === alphabet) {
        return;
    }

    if (_alphabet_.length !== ORIGINAL.length) {
        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. You submitted ' + _alphabet_.length + ' characters: ' + _alphabet_);
    }

    var unique = _alphabet_.split('').filter(function(item, ind, arr){
       return ind !== arr.lastIndexOf(item);
    });

    if (unique.length) {
        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. These characters were not unique: ' + unique.join(', '));
    }

    alphabet = _alphabet_;
    reset();
}

function characters(_alphabet_) {
    setCharacters(_alphabet_);
    return alphabet;
}

function setSeed(seed) {
    randomFromSeed.seed(seed);
    if (previousSeed !== seed) {
        reset();
        previousSeed = seed;
    }
}

function shuffle() {
    if (!alphabet) {
        setCharacters(ORIGINAL);
    }

    var sourceArray = alphabet.split('');
    var targetArray = [];
    var r = randomFromSeed.nextValue();
    var characterIndex;

    while (sourceArray.length > 0) {
        r = randomFromSeed.nextValue();
        characterIndex = Math.floor(r * sourceArray.length);
        targetArray.push(sourceArray.splice(characterIndex, 1)[0]);
    }
    return targetArray.join('');
}

function getShuffled() {
    if (shuffled) {
        return shuffled;
    }
    shuffled = shuffle();
    return shuffled;
}

/**
 * lookup shuffled letter
 * @param index
 * @returns {string}
 */
function lookup(index) {
    var alphabetShuffled = getShuffled();
    return alphabetShuffled[index];
}

function get () {
  return alphabet || ORIGINAL;
}

module.exports = {
    get: get,
    characters: characters,
    seed: setSeed,
    lookup: lookup,
    shuffled: getShuffled
};


/***/ }),

/***/ 1693:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var generate = __webpack_require__(13365);
var alphabet = __webpack_require__(1252);

// Ignore all milliseconds before a certain time to reduce the size of the date entropy without sacrificing uniqueness.
// This number should be updated every year or so to keep the generated id short.
// To regenerate `new Date() - 0` and bump the version. Always bump the version!
var REDUCE_TIME = 1567752802062;

// don't change unless we change the algos or REDUCE_TIME
// must be an integer and less than 16
var version = 7;

// Counter is used when shortid is called multiple times in one second.
var counter;

// Remember the last time shortid was called in case counter is needed.
var previousSeconds;

/**
 * Generate unique id
 * Returns string id
 */
function build(clusterWorkerId) {
    var str = '';

    var seconds = Math.floor((Date.now() - REDUCE_TIME) * 0.001);

    if (seconds === previousSeconds) {
        counter++;
    } else {
        counter = 0;
        previousSeconds = seconds;
    }

    str = str + generate(version);
    str = str + generate(clusterWorkerId);
    if (counter > 0) {
        str = str + generate(counter);
    }
    str = str + generate(seconds);
    return str;
}

module.exports = build;


/***/ }),

/***/ 13365:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var alphabet = __webpack_require__(1252);
var random = __webpack_require__(20732);
var customRandom = (__webpack_require__(75578)/* .customRandom */ .AO);

function generate(number) {
    var loopCounter = 0;
    var done;

    var str = '';

    while (!done) {
        str = str + customRandom(alphabet.get(), 1, random)();
        done = number < (Math.pow(16, loopCounter + 1 ) );
        loopCounter++;
    }
    return str;
}

module.exports = generate;


/***/ }),

/***/ 79371:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var alphabet = __webpack_require__(1252);
var build = __webpack_require__(1693);
var isValid = __webpack_require__(47210);

// if you are using cluster or multiple servers use this to make each instance
// has a unique value for worker
// Note: I don't know if this is automatically set when using third
// party cluster solutions such as pm2.
var clusterWorkerId = __webpack_require__(59424) || 0;

/**
 * Set the seed.
 * Highly recommended if you don't want people to try to figure out your id schema.
 * exposed as shortid.seed(int)
 * @param seed Integer value to seed the random alphabet.  ALWAYS USE THE SAME SEED or you might get overlaps.
 */
function seed(seedValue) {
    alphabet.seed(seedValue);
    return module.exports;
}

/**
 * Set the cluster worker or machine id
 * exposed as shortid.worker(int)
 * @param workerId worker must be positive integer.  Number less than 16 is recommended.
 * returns shortid module so it can be chained.
 */
function worker(workerId) {
    clusterWorkerId = workerId;
    return module.exports;
}

/**
 *
 * sets new characters to use in the alphabet
 * returns the shuffled alphabet
 */
function characters(newCharacters) {
    if (newCharacters !== undefined) {
        alphabet.characters(newCharacters);
    }

    return alphabet.shuffled();
}

/**
 * Generate unique id
 * Returns string id
 */
function generate() {
  return build(clusterWorkerId);
}

// Export all other functions as properties of the generate function
module.exports = generate;
module.exports.generate = generate;
module.exports.seed = seed;
module.exports.worker = worker;
module.exports.characters = characters;
module.exports.isValid = isValid;


/***/ }),

/***/ 47210:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var alphabet = __webpack_require__(1252);

function isShortId(id) {
    if (!id || typeof id !== 'string' || id.length < 6 ) {
        return false;
    }

    var nonAlphabetic = new RegExp('[^' +
      alphabet.get().replace(/[|\\{}()[\]^$+*?.-]/g, '\\$&') +
    ']');
    return !nonAlphabetic.test(id);
}

module.exports = isShortId;


/***/ }),

/***/ 20732:
/***/ (function(module) {

"use strict";


var crypto = typeof window === 'object' && (window.crypto || window.msCrypto); // IE 11 uses window.msCrypto

var randomByte;

if (!crypto || !crypto.getRandomValues) {
    randomByte = function(size) {
        var bytes = [];
        for (var i = 0; i < size; i++) {
            bytes.push(Math.floor(Math.random() * 256));
        }
        return bytes;
    };
} else {
    randomByte = function(size) {
        return crypto.getRandomValues(new Uint8Array(size));
    };
}

module.exports = randomByte;


/***/ }),

/***/ 32943:
/***/ (function(module) {

"use strict";


// Found this seed-based random generator somewhere
// Based on The Central Randomizer 1.3 (C) 1997 by Paul Houle (houle@msc.cornell.edu)

var seed = 1;

/**
 * return a random number based on a seed
 * @param seed
 * @returns {number}
 */
function getNextValue() {
    seed = (seed * 9301 + 49297) % 233280;
    return seed/(233280.0);
}

function setSeed(_seed_) {
    seed = _seed_;
}

module.exports = {
    nextValue: getNextValue,
    seed: setSeed
};


/***/ }),

/***/ 59424:
/***/ (function(module) {

"use strict";


module.exports = 0;


/***/ }),

/***/ 75578:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AO": function() { return /* binding */ customRandom; }
/* harmony export */ });
/* unused harmony exports nanoid, customAlphabet, random */

let random = bytes => crypto.getRandomValues(new Uint8Array(bytes))
let customRandom = (alphabet, defaultSize, getRandom) => {
  let mask = (2 << (Math.log(alphabet.length - 1) / Math.LN2)) - 1
  let step = -~((1.6 * mask * defaultSize) / alphabet.length)
  return (size = defaultSize) => {
    let id = ''
    while (true) {
      let bytes = getRandom(step)
      let j = step | 0
      while (j--) {
        id += alphabet[bytes[j] & mask] || ''
        if (id.length === size) return id
      }
    }
  }
}
let customAlphabet = (alphabet, size = 21) =>
  customRandom(alphabet, size, random)
let nanoid = (size = 21) =>
  crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte) => {
    byte &= 63
    if (byte < 36) {
      id += byte.toString(36)
    } else if (byte < 62) {
      id += (byte - 26).toString(36).toUpperCase()
    } else if (byte > 62) {
      id += '-'
    } else {
      id += '_'
    }
    return id
  }, '')



/***/ })

}]);